import React/*,  { useState } */, {useMemo, useState} from "react";
import {Button, Modal, ModalBody, Table, /*  Button, Row, Col */} from "reactstrap";
import {Link, useNavigate} from "react-router-dom";
import { AI } from "../common/Icons"


const AskPaymentModal = ({ open, close, size = "md", handleSkip, user }) => {
    const navigate = useNavigate();
    const [showTaxTable, setShowTaxTable] = useState(false);
    /* const [email, setEmail] = useState("") */
    const handleClose = () => {
        close(false);
    };
    const handleYes = () => {
        navigate('/payment',{ state: { user } })
    };

    const taxData = [
        { province: "Alberta, British Columbia, Manitoba, Northwest Territories, Nunavut, Quebec, Saskatchewan, Yukon", rate: "5% (GST)" },
        { province: "Ontario", rate: "13% (HST)" },
        { province: "Nova Scotia (on or after April 1, 2025)", rate: "14% (HST)" },
        { province: "New Brunswick, Newfoundland and Labrador, Nova Scotia (until March 31, 2025), Prince Edward Island", rate: "15% (HST)" },
    ];

    const { trialEnded, remainingDays } = useMemo(() => {
        const trialEndDate = user?.data?.trial_ends_at
            ? new Date(user.data.trial_ends_at)
            : null;
        const today = new Date();
        if (!trialEndDate) {
            return { trialEnded: false, remainingDays: 15 };
        }

        const diffTime = trialEndDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return {
            trialEnded: diffDays <= 0,
            remainingDays: diffDays > 0 ? diffDays : 0,
        };
    }, [user?.data?.trial_ends_at]);

    return (
    <Modal
            isOpen={open}
            toggle={handleClose}
            centered
            size={'xl'}
            className="position-relative"
        >
            <ModalBody className="p-0 rounded-4 shadow-lg bg-white h-100 d-flex flex-column justify-content-center">
                {/* Close Button */}
                <div className="modal--close-button">
                    <AI.AiOutlineCloseCircle
                        size={28}
                        className="cursor-pointer position-absolute end-0 top-0 m-3 text-muted"
                        onClick={handleClose}
                    />
                </div>

                {/* Modal Content */}
                <div className="p-5 text-center w-100">
                    <h4 className="mb-3 fw-bold text-dark fs-3">Welcome {user?.data?.first_name}</h4>
                    <p className="mb-2 fs-5 text-dark">Would you like to enter your card details now?</p>
                    <p className="text-muted small">
                        Don’t worry – you won’t be charged now. Payment will only be required after your 14-day free trial ends.
                    </p>

                    <p className="fw-semibold mt-4 text-warning">
                        {trialEnded ? (
                            <span className="text-danger fw-bold">Your trial has ended.</span>
                        ) : (
                            <>
                                You have{" "}
                                <span className="text-danger fw-bold">
                                    {remainingDays} {remainingDays === 1 ? "day" : "days"}
                                </span>{" "}
                                left in your trial.
                            </>
                        )}
                    </p>

                    {/* Show/Hide Tax Table Button */}
                    <Button
                        color="link"
                        className="fw-bold text-decoration-underline mt-3"
                        onClick={() => setShowTaxTable(!showTaxTable)}
                    >
                        {showTaxTable ? "Hide Charges with Tax" : "Show Charges with Tax"}
                    </Button>

                    {/* Tax Table */}
                    {showTaxTable && (
                        <div className="mt-3">
                            <h6 className="fw-bold mb-3">Annual Fee: $99 CAD + Applicable Taxes</h6>
                            <Table bordered hover responsive striped className="shadow-sm rounded">
                                <thead className="table-dark">
                                <tr>
                                    <th>Province / Territory</th>
                                    <th>Tax Rate</th>
                                    <th>Total (with Tax)</th>
                                </tr>
                                </thead>
                                <tbody>
                                {taxData.map((item, index) => {
                                    const taxRate = parseFloat(item.rate);
                                    const total = taxRate
                                        ? (99 + (99 * taxRate / 100)).toFixed(2)
                                        : "99.00";
                                    return (
                                        <tr key={index}>
                                            <td className="text-start">{item.province}</td>
                                            <td>{item.rate}</td>
                                            <td className="fw-semibold">${total} CAD</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mt-4">
                        {trialEnded ? (
                            <Button
                                color="light"
                                className="border fw-bold px-4 py-2"
                                onClick={handleSkip}
                            >
                                Continue Free Trial
                            </Button>
                        ) : (
                            <>
                                <Button
                                    color="light"
                                    className="border fw-bold px-4 py-2"
                                    onClick={handleSkip}
                                >
                                    Continue Free Trial
                                </Button>
                                <Button
                                    className="px-4 py-2 fw-bold w-25 text-white custom-primary-btn"
                                    onClick={handleYes}
                                >
                                    Yes
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </ModalBody>
        </Modal>



    );
};

export default AskPaymentModal;